import { take, put } from 'redux-saga/effects';
import { routeActions } from 'redux-simple-router';

import { LOGOUT } from 'modules/auth/constants/actionTypes';

export function *redirectOnLogout() {
    while(true) {
        yield take(LOGOUT);
        yield put(routeActions.push('/login'));
    }
}

